module.exports = __webpack_public_path__ + "img/view-grid.a373a85d.svg";